var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"help-page"},[_c('UEditor',{model:{value:(_vm.content),callback:function ($$v) {_vm.content=$$v},expression:"content"}}),_c('div',{staticClass:"submit"},[_c('Button',{attrs:{"size":"large","type":"primary"},on:{"click":_vm.setQues}},[_vm._v("保存")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }